import CreateDestination from '../components/templates/create';

export const CreateDestinationContainer = () => {
  return <CreateDestination />;
};
